export const FEATURE_FLAGS = {
  SHOW_ADMIN_TABLE_FOOTER: true
};
